









































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import CountriesStore from "@/mixins/constants/countriesStore";

// Data
import { AddressTypes } from "@/data/status";
import { ActionTypes } from "@/data/enums";

// Types
import { IAddressForm } from "@/models/addresses";

@Component({
  components: {
    "address-search": () =>
      import("@/components/app/global/address/addressSearch.vue"),
    "address-form": () =>
      import("@/components/app/global/address/addressForm.vue")
  }
})
export default class AddEditAddressForm extends Mixins(
  RequestPromises,
  CountriesStore
) {
  @Prop({ required: true })
  public form!: IAddressForm;

  @Prop({ default: "create" })
  public formType!: string;

  @Prop({ required: true })
  public isProcessing!: number;

  @Prop({ default: false })
  public googleSearch!: boolean;

  @Prop({ default: "" })
  public searchedValue!: string;

  public addressTypes: any = this.$_.clone(AddressTypes);
  public actionType = ActionTypes;

  public onResult(result: IAddressForm, searchedValue: string) {
    this.$emit("onResult", result, searchedValue);
  }
}
